export default "__VITE_ASSET__BewJ3NF6__"